@if (useContent() || message()) {
  <div class="noti-box" [style.background-color]="color()">
    @switch (type()) {
      @case ('error') {
        <i class="material-symbols-outlined">warning</i>
      }
      @case ('info') {
        <i class="material-symbols-outlined">info</i>
      }
      @case ('news') {
        <i class="material-symbols-outlined">description</i>
      }
    }
    <div class="limit-width">
      @if (useContent()) {
        @if (useContent()) {
          <ng-content></ng-content>
        }
      } @else {
        @if (message(); as message) {
          <p class="mb-0">{{ message }}</p>
        }
      }
    </div>
  </div>
}
